export const QUERY_PARAM_PATH_AFTER_LOGIN = 'loginPath';
